import Tooltip from '@components/common/Tooltip';

const Chart1 = () => {
    return (
        <>
            <div className="custom-card overflow-hidden card">
                <div className="justify-content-between card-header">
                    <div className="card-title">
                        토양층수분{' '}
                        <Tooltip
                            content="도움말이 표시될예정"
                            customClass="tooltip-dark"
                            placement="top"
                        >
                            <i className="ri-question-line" />
                        </Tooltip>
                    </div>
                </div>
                <div className="p-0 card-body">
                    <div className="table-responsive">
                        <table className="text-nowrap table">
                            <thead>
                                <tr>
                                    <th>토양층</th>
                                    <th>깊이</th>
                                    <th>수분상태</th>
                                    <th>수분량</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-table-soil1 soil-row">
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div>1층</div>
                                        </div>
                                    </td>
                                    <td className="fw-semibold fs-15">
                                        0~20cm
                                    </td>
                                    <td>
                                        <span className="fw-medium badge fs-11 bg-success">
                                            적정
                                        </span>
                                    </td>
                                    <td className="fw-medium">66.4mm</td>
                                </tr>
                                <tr className="bg-table-soil2 soil-row">
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div>2층</div>
                                        </div>
                                    </td>
                                    <td className="fw-semibold fs-15">
                                        5-15cm
                                    </td>
                                    <td>
                                        <span className="fw-medium badge fs-11 bg-info">
                                            과다
                                        </span>
                                    </td>
                                    <td className="fw-medium">66.4mm</td>
                                </tr>
                                <tr className="bg-table-soil3 soil-row">
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div>3층</div>
                                        </div>
                                    </td>
                                    <td className="fw-semibold fs-15">
                                        15-24cm
                                    </td>
                                    <td>
                                        <span className="fw-medium badge fs-11 bg-pink">
                                            부족
                                        </span>
                                    </td>
                                    <td className="fw-medium">66.4mm</td>
                                </tr>
                                <tr className="bg-table-soil4 soil-row">
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div>4층</div>
                                        </div>
                                    </td>
                                    <td className="fw-semibold fs-15">
                                        24-36cm
                                    </td>
                                    <td>
                                        <span className="fw-medium badge fs-11 bg-primary">
                                            침수
                                        </span>
                                    </td>
                                    <td className="fw-medium">66.4mm</td>
                                </tr>
                                <tr className="bg-table-soil5 soil-row">
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div>5층</div>
                                        </div>
                                    </td>
                                    <td className="fw-semibold fs-15">
                                        36-48cm
                                    </td>
                                    <td>
                                        <span className="fw-medium badge fs-11 bg-danger">
                                            가뭄
                                        </span>
                                    </td>
                                    <td className="fw-medium">66.4mm</td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
